import React from "react";
import { MARQUEE_WORDS } from "../../data";

export const Marquee = () => {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section
      data-testid="marquee-section"
      className="relative py-10 border-y border-white/10 bg-[#0a0a0c] overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {items.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-black text-4xl sm:text-6xl uppercase text-transparent text-stroke px-8">
              {w}
            </span>
            <span className="text-[#b533ff] text-3xl">★</span>
          </div>
        ))}
      </div>
    </section>
  );
};
